import {
  SaveCreditCardParams,
  CreditCardsRepositoryInterface,
  GetStoredUserCreditCardsParams,
  DeleteCardParams,
  SetMainCardParams,
} from '../domain/CreditCardsRepositoryInterface.types';
import { inject, injectable } from 'inversify';
import CreditCardsService from 'src/features/creditCards/data/service/CreditCardsService';

@injectable()
class CreditCardsRepository implements CreditCardsRepositoryInterface {
  @inject(CreditCardsService)
  private readonly creditCardsService!: CreditCardsService;

  public async saveCreditCard(params: SaveCreditCardParams) {
    const response = await this.creditCardsService.storeUserCreditCard(params);

    return response.data;
  }

  public async getStoredUserCreditCards({
    ...params
  }: GetStoredUserCreditCardsParams) {
    const response = await this.creditCardsService.getUserCreditCards(params);
    return response.data;
  }

  public async deleteCard(params: DeleteCardParams) {
    await this.creditCardsService.deleteUserCreditCard(params);
  }

  public async setMainCard({ userId, cardId, accessToken }: SetMainCardParams) {
    await this.creditCardsService.setMainCreditCard({
      userId,
      cardId,
      accessToken,
    });
  }
}

export default CreditCardsRepository;
